export default __webpack_public_path__ + "static/media/Cesta_green.b7206dc3.svg";